const basicsTemplates = {
  hero: ["default", "content", "minimal", "carousel", "ads", "garantie"],
  carousel: [
    "simple",
    "produits",
    "categorie",
    "bestsellers",
    "reduction",
    "latest-products",
  ],
  "2-col": [
    "with-ss",
    "without-ss",
    "without-ss-inverse",
    "2-images",
    "contact",
    "partners",
  ],
  calltoaction: ["contact", "centered", "2-col", "left", "newsletter"],
  grid: [
    "cards",
    "blog-cards",
    "cards-without-image",
    "video",
    "galeries",
    "ytb-videos",
  ],
  faq: ["accordeon", "list"],
};

export const templateTypeVariants = {
  default: {
    ...basicsTemplates,
  },

  detail: {
    ...basicsTemplates,
  },

  rdv: {
    ...basicsTemplates,
    hero: [...(basicsTemplates.hero || []), ""],
  },
};

export const booleanFields = [
  "coiffure",
  "manicure",
  "pedicure",
  "maquillage",
  "soin_visage",
  "extensions_cils",
  "autres",
];
